// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip--hID_0","Tooltip--bottom":"Tooltip--bottom--BAf2O","Tooltip--top":"Tooltip--top--ovDj5"};